<template>
  <div class='selector'>
    <div class='selector-container'>
      <div class='selector-arrow selector-arrow_left' @click='moveToPreviousService()'></div>
      <div class="selector-txt-container selector-txt-services">
        <div class='selector-ico-services'></div>
        <div id='serviceToPrint' class='selector-txt'>
          {{ getSelectedSubService }}
        </div>
        <el-select v-model="valueSelect" value-key="id" @change="setSelectedServiceC">
          <el-option v-for="item in getSelectedDayServicesData" :key="item.id" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class='selector-arrow selector-arrow_right' @click='moveToNextService()'></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ServicesNav',
  data() {
    return {
      valueSelect: ''
    }
  },
  computed: {
    ...mapGetters({
      getSelectedSubService: 'newServices/getSelectedSubService',
      getMainServicesForDay: 'newServices/getMainServicesForDay',
      getSelectedDay: 'calendar/getSelectedDay'
    }),
    getSelectedDayServicesData: function () {
      let subServices = []
      let servicesForDay = this.getMainServicesForDay(this.getSelectedDay)
      if (servicesForDay !== undefined) {
        let count = 0
        let needToReSetSelected = false
        servicesForDay.forEach((service) => {
          if (!service.isClosed) {
            let o = {
              name: service.subName,
              value: {
                subs: service.subName,
                ms: service.name,
                id: count
              }
            }
            subServices.push(o)
            if (this.getSelectedSubService === o.name) this.valueSelect = o.value
            count += 1
          } else if (this.getSelectedSubService === service.subName) {
            needToReSetSelected = true
          }
        })
        if (needToReSetSelected && subServices.length > 0) {
          this.valueSelect = subServices[0].value
          this.setSelectedService({ ms: subServices[0].name, subs: subServices[0].name })
        }
        return subServices
      }
    }
  },
  methods: {
    ...mapActions({
      moveToPreviousService: 'newServices/moveToPreviousService',
      moveToNextService: 'newServices/moveToNextService',
      findSelectedServiceByDay: 'newServices/findSelectedServiceByDay'
    }),
    ...mapMutations({
      setSelectedService: 'newServices/setSelectedService',
      setModSwitchTable: 'newReservations/setModSwitchTable'
    }),
    setSelectedServiceC: function (selected) {
      this.setSelectedService({ ms: selected.ms, subs: selected.subs })
      this.setModSwitchTable(false)
    }
  }
}
</script>

<style lang="scss"></style>
